<template>
    <div style="height: 100%">
      <label><b-icon icon="circle" style="margin-right: 5px;"></b-icon>安防设备</label>
      <el-row style="height: 10vh;">
        <el-col :span="8" class="text-center" v-if="data.accessCount > 0">
          <div class="device-circle pointer" @touchstart="toRouter('/device-list','list')"  @click="toRouter('/device-list','list')">
            <span id="accessCount">{{ data.accessCount }}</span>个
          </div>
          <span class="device-name">门禁</span>
        </el-col>
        <el-col :span="8" class="text-center" v-if="data.videoCount > 0">
          <div class="device-circle pointer" @touchstart="toRouter('/device-list','list')"  @click="toRouter('/device-list','list')">
            <span id="videoCount">{{ data.videoCount }}</span>个
          </div>
          <span class="device-name">摄像头</span>
        </el-col>
        <el-col :span="8" class="text-center" v-if="data.leakCount > 0">
          <div class="device-circle pointer" @touchstart="toRouter('/device-list','list')"  @click="toRouter('/device-list','list')">
            <span id="leakCount">{{ data.leakCount }}</span>个
          </div>
          <span class="device-name">漏水</span>
        </el-col>
      </el-row>
      <label style="padding: 1.2vh 30px">
        <b-icon icon="circle" style="margin-right: 5px;"></b-icon>
        消防设备</label>
      <el-row style="height: 10vh;">
        <el-col :span="8" class="text-center" v-if="data.smokeCount > 0">
          <div class="device-circle pointer" @touchstart="toRouter('/device-list','list')"  @click="toRouter('/device-list','list')">
            <span id="smokeCount">{{ data.smokeCount }}</span>个
          </div>
          <span class="device-name">烟感</span>
        </el-col>
        <el-col :span="8" class="text-center" v-if="data.xfygCount > 0">
          <div class="device-circle pointer" @touchstart="toRouter('/device-list','list')"  @click="toRouter('/device-list','list')">
            <span id="smokeCount">{{ data.xfygCount }}</span>个
          </div>
          <span class="device-name">烟感</span>
        </el-col>
        <el-col :span="8" class="text-center" v-if="data.fireCount > 0">
          <div class="device-circle pointer" @touchstart="toRouter('/device-list','list')"  @click="toRouter('/device-list','list')">
            <span id="fireCount">{{ data.fireCount }}</span>个
          </div>
          <span class="device-name">消防主机</span>
        </el-col>
        <el-col :span="8" class="text-center" v-if="data.xfwgCount > 0">
          <div class="device-circle pointer" @touchstart="toRouter('/device-list','list')"  @click="toRouter('/device-list','list')">
            <span id="fireCount">{{ data.xfwgCount }}</span>个
          </div>
          <span class="device-name">温感</span>
        </el-col>
        <el-col :span="8" class="text-center" v-if="data.xfqtCount > 0">
          <div class="device-circle pointer" @touchstart="toRouter('/device-list','list')"  @click="toRouter('/device-list','list')">
            <span id="fireCount">{{ data.xfqtCount }}</span>个
          </div>
          <span class="device-name">其他</span>
        </el-col>
      </el-row>
    </div>
</template>

<script>
import {getDeviceSummary} from "@/network/device-info";
import platenLayoutEdit from '@/mixins/platenLayoutEdit'

export default {
  name: "SecurityDevice",
  mixins: [platenLayoutEdit],
  components: {},
  data() {
    return {
      data: {}
    }
  },
  created() {
    this.getSummaryData();
    this.$store.dispatch('addIntervalObj', {'getSecurityDevice:5000': this.getData})
  },
  destroyed() {
    this.$store.dispatch('removeIntervalObj', 'getSecurityDevice')
  },
  methods: {
    //设备数量统计(安防消防各设备数量,机房数量等)
    getSummaryData() {
      getDeviceSummary().then(res => {
        if (res.code === 0) {
          this.data = res.data
        }
      })
    },
    toRouter(router,mode){
      if (this.isPlatenLayoutEditing) return
      // let routeUrl = this.$router.resolve({
      //   path: router,
      //   query: {mode: mode}
      // });
      // window.open(routeUrl.href, '_blank')
      this.$router.push({
        path: router,
        query: {mode: mode}
      })
    }
  }
}
</script>

<style scoped>
label {
  padding: 20px 30px 1.5vh 30px;
  font-weight: bold;
  color: #01EFFD;
}
.device-circle {
  width: 9vh;
  height: 9vh;
  border-radius: 50%;
  border: 4px solid #30C4E9;
  margin: 0 auto 5px;
  font-size: 1.06rem;
  line-height: 8vh;
  color: #fff;
}

.device-name {
  font-size: 0.9rem;
  font-weight: bold;
  color: #01EFFD;
}
</style>
